


















































































import useUsers from "@/composables/useUsers";
import useQuotedEntryJump from "@/composables/v3/useQuotedEntryJump";
import i18n from "@/libs/i18n";
import { useChatsStore } from "@/store/useChatsStore";
import { useContactsStore } from "@/store/useContactsStore";
import { downloadFile, getFullPath } from "@/utils/assets";
import { resolveEntryIcon, resolveReplyMessage, resolveSenderName } from "@/utils/chats";
import { scrollToEntry } from "@/views/modules/messaging-inbox/useChat";
import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { BButton, BImg, BModal } from "bootstrap-vue";
import { v4 as uuidv4 } from "uuid";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        BImg,
        BModal,
        BButton,
    },
    props: {
        replyToMessageId: {
            required: true,
            type: Number,
        },
        position: {
            type: String as PropType<"chatlog" | "compose">,
            required: true,
        },
    },
    setup(props, context) {
        const chatsStore = useChatsStore();
        const contactsStore = useContactsStore();
        const { users } = useUsers();

        const originalEntry = ref(
            chatsStore.activeChat?.entries.find(
                (entry) => entry.id === props.replyToMessageId && ["text", "attachment"].includes(entry.type)
            )
        );
        const message = computed((): string => resolveReplyMessage(originalEntry.value));
        const icon = computed((): string | string[] => resolveEntryIcon(originalEntry.value));
        const sender = computed((): string =>
            resolveSenderName(originalEntry.value, users.value, contactsStore.activeChatContact)
        );

        const uuid = uuidv4();

        if (!originalEntry.value) {
            if (!chatsStore.activeChat) {
                return;
            }

            chatsStore.fetchEntry(props.replyToMessageId).then((foundEntry) => {
                originalEntry.value = foundEntry;
            });
        }

        const toast = useToast();
        const localDownloadFile = (asset) => downloadFile(asset).catch(() => toast.error(i18n.t("toast.read.error")));

        const selectAsset = (): void => {
            if (originalEntry.value.type !== "attachment" || !originalEntry.value.assets?.length) {
                return;
            }

            if (originalEntry.value.assets[0].category === "image") {
                context.root.$bvModal.show(`reply-modal-${uuid}`);
                return;
            }

            localDownloadFile(originalEntry.value.assets[0]);
        };

        const { isQuotedEntryAvailable } = useQuotedEntryJump();
        return {
            scrollToEntry,
            isQuotedEntryAvailable,
            originalEntry,
            sender,
            icon,
            message,
            uuid,
            getFullPath,
            localDownloadFile,
            selectAsset,
        };
    },
});
